import type { RouteObject } from 'react-router-dom';
import Home from '@/pages/home/page';
import NotFound from '@/pages/NotFound';
import LoginPage from '@/pages/auth/login/page';
import RegisterPage from '@/pages/auth/register/page';
import UnderReviewPage from '@/pages/auth/under-review/page';
import DashboardPage from '@/pages/dashboard/page';
import OrdersPage from '@/pages/orders/page';
import OrderDetailPage from '@/pages/orders/detail/page';
import AssignDriverPage from '@/pages/orders/assign/page';
import ItemsPage from '@/pages/items/page';
import ItemFormPage from '@/pages/items/form/page';
import PackagesPage from '@/pages/packages/page';
import PackageFormPage from '@/pages/packages/form/page';
import SubscribersPage from '@/pages/packages/subscribers/page';
import DriversPage from '@/pages/drivers/page';
import DriverProfilePage from '@/pages/drivers/profile/page';
import DriverFormPage from '@/pages/drivers/form/page';
import ResetPasswordPage from '@/pages/drivers/reset-password/page';
import FinancePage from '@/pages/finance/page';
import SettingsPage from '@/pages/settings/page';
import RatingsPage from '@/pages/ratings/page';
import NotificationsPage from '@/pages/notifications/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/auth/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/register',
    element: <RegisterPage />,
  },
  {
    path: '/auth/under-review',
    element: <UnderReviewPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/orders',
    element: <OrdersPage />,
  },
  {
    path: '/orders/detail/:id',
    element: <OrderDetailPage />,
  },
  {
    path: '/orders/assign',
    element: <AssignDriverPage />,
  },
  {
    path: '/items',
    element: <ItemsPage />,
  },
  {
    path: '/items/new',
    element: <ItemFormPage />,
  },
  {
    path: '/items/:id/edit',
    element: <ItemFormPage />,
  },
  {
    path: '/packages',
    element: <PackagesPage />,
  },
  {
    path: '/packages/new',
    element: <PackageFormPage />,
  },
  {
    path: '/packages/:id/edit',
    element: <PackageFormPage />,
  },
  {
    path: '/packages/:id/subscribers',
    element: <SubscribersPage />,
  },
  {
    path: '/drivers',
    element: <DriversPage />,
  },
  {
    path: '/drivers/new',
    element: <DriverFormPage />,
  },
  {
    path: '/drivers/:id',
    element: <DriverProfilePage />,
  },
  {
    path: '/drivers/:id/edit',
    element: <DriverFormPage />,
  },
  {
    path: '/drivers/:id/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/finance',
    element: <FinancePage />,
  },
  {
    path: '/ratings',
    element: <RatingsPage />,
  },
  {
    path: '/notifications',
    element: <NotificationsPage />,
  },
  {
    path: '/settings',
    element: <SettingsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;